import { render, staticRenderFns } from "./InputTime.vue?vue&type=template&id=56f28ba5&scoped=true&"
import script from "./InputTime.vue?vue&type=script&lang=js&"
export * from "./InputTime.vue?vue&type=script&lang=js&"
import style0 from "./InputTime.vue?vue&type=style&index=0&id=56f28ba5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f28ba5",
  null
  
)

export default component.exports